import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import SearchKeywordResult from '@/components/Approval/@components/ApprovalHeader/SearchKeywordResult';
import {
  BoldText,
  HeaderContainer,
  SearchResultContainer,
  SubHeader,
} from './styles';
import { Stack } from '@mui/material';

type ApprovalHeaderProps = {
  // Breadcrumb
  breadcrumb?: ReactNode;

  // Count
  totalCount?: number;
  keyword?: string;
  /**
   * 지정 시 키워드 인용("'X'에 대한…") 대신 개수만 표시한다.
   * 통합/제목/내용 등 검색어가 여러 개일 수 있는 화면(WORK 결재)에서 사용.
   * true = 검색 적용 중("총 N건의 검색결과"), false = 검색 없음("총 N건").
   */
  isSearching?: boolean;

  // Buttons & Components
  leftButton?: ReactNode;
  filterComponent?: ReactNode;
  searchComponent?: ReactNode;

  // Responsive
  isTablet: boolean;
};

/** Approval 페이지 헤더 영역 */
const ApprovalHeader = ({
  breadcrumb,
  totalCount,
  keyword,
  isSearching,
  leftButton,
  filterComponent,
  searchComponent,
}: ApprovalHeaderProps) => {
  const { t } = useTranslation();

  return (
    <HeaderContainer>
      {/* Breadcrumb */}
      <Stack
        direction="row"
        sx={{
          padding: '12px 0',
          display: 'flex',
          alignItems: 'center',
          borderBottom: '1px solid var(--dk-line, #E7E9EC)',
        }}
      >
        {breadcrumb}
      </Stack>

      {/* Filter & Search */}
      <Stack sx={{ zIndex: 100 }}>
        {filterComponent}
        <SubHeader
          sx={{
            display: 'flex',
            width: '100%',
            gap: '16px',
          }}
        >
          <SearchResultContainer>
            {/*
              isSearching 지정 시(WORK): 검색어가 여러 개일 수 있어 인용 없이 개수만.
              그 외(문서함): 통합 키워드 하나면 인용, 없으면 전체 건수.
            */}
            {isSearching !== undefined ? (
              <Stack direction={'row'}>
                {t('총')}
                <BoldText>{' ' + (totalCount?.toLocaleString() || 0)}</BoldText>
                {isSearching ? t('건의 검색결과') : t('건')}
              </Stack>
            ) : keyword ? (
              <SearchKeywordResult keyword={keyword} searchCount={totalCount} />
            ) : (
              <Stack direction={'row'}>
                {t('총')}
                <BoldText>{' ' + (totalCount?.toLocaleString() || 0)}</BoldText>
                {t('건')}
              </Stack>
            )}
            {leftButton}
          </SearchResultContainer>
          {searchComponent}
        </SubHeader>
      </Stack>
    </HeaderContainer>
  );
};

export default ApprovalHeader;
